export default {
  namespaced: true,
  state: {
    drawer: {
      open: null
    },
    toolbar: {
      title: "Dashboard"
    },
    snackbar: {
      open: false,
      color: "",
      text: ""
    }
  },
  getters: {},
  mutations: {
    toggleDrawer(state, value) {
      state.drawer.open = value;
    },
    changeToolbar(state, options) {
      state.toolbar = { toolbar, ...options };
    },
    setSnackbar(state, options) {
      state.snackbar.text = options.text || "";
      state.snackbar.open = options.open || true;
      state.snackbar.color = options.color || "error";
    },
    closeSnackbar(state) {
      state.snackbar.open = false;
    }
  },
  actions: {}
};
